export enum WorkspaceSidebarToken {
  Hamburger = 'workspace-sidebar-hamburger',
  Notifications = 'notifications',
}
